import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "src/app/_services";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-space-assignment-view",
  templateUrl: "./space-assignment-view.component.html",
  styleUrls: [
    "./space-assignment-view.component.scss",
    "./../../../../_styles/ion-grid-content-table.scss",
  ],
})
export class SpaceAssignmentViewComponent {
  constructor(
    private userServ: UserService,
    public alertController: AlertController,
    public translateService: TranslateService
  ) {}

  permissionEdit = false;
  hideUser: boolean;
  currentLang = this.translateService.currentLang;

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Input()
  customData;

  @Input()
  spaceType;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    let permissionEdit;

    switch (this.spaceType) {
      case SpaceType.Parking:
        permissionEdit = "parking.space.assignment.edit";
        break;
      case SpaceType.Desk:
        permissionEdit = "desk.space.assignment.edit";
        break;
      case SpaceType.Room:
        permissionEdit = "room.space.assignment.edit";
        break;
    }

    this.permissionEdit = this.userServ.hasRoles([permissionEdit]);
    this.hideUser = this.customData == "hideUserColumn" ? true : false;
  }

  onDelete($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.actionRequest.emit({
      type: "remove",
      id: this.row.id,
    });
  }

  onEdit($event) {
    $event.preventDefault();
    $event.stopPropagation();

    if (this.permissionEdit) {
      this.actionRequest.emit({
        type: "edit",
        id: this.row.id,
      });
    }
  }
}
